import { useCallback } from "react"
import { graphql, useMutation } from "react-relay"
import { De_updatePatientCaveEntryInput } from "@/modules/patients/services/de/__generated__/useDePatientUpdateCaveMutation.graphql.ts"

const mutation = graphql`
  mutation useDePatientUpdateCaveMutation($input: De_updatePatientCaveEntryInput!) {
    de_updatePatientCaveEntry(input: $input) {
      de_Patient {
        caveEntry {
          message
          updatedAt
          updatedBy
        }
      }
    }
  }
`

export function useDePatientUpdateCaveMutation() {
  const [commit] = useMutation(mutation)

  return useCallback(
    (input: De_updatePatientCaveEntryInput, handleComplete?: () => void) => {
      commit({
        variables: { input },
        onCompleted: handleComplete,
      })
    },
    [commit],
  )
}
